import { fetchAuthSession } from "@aws-amplify/auth";

export async function getCognitoToken() {
  try {
    const session = await fetchAuthSession();

    const accessToken = session.tokens?.accessToken?.toString();

    return { accessToken };
  } catch (error) {
    console.error("Error fetching auth session:", error);
  }
}
